<template>
    <!-- begin:: Page -->
    <div class="m-grid m-grid--hor m-grid--root m-page outer-box">
        <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 m-login--signin"
             id="m_login">
            <div class="m-grid__item m-grid__item--order-tablet-and-mobile-2 m-login__aside">
                <div class="m-stack m-stack--hor m-stack--desktop">
                    <div class="m-stack__item m-stack__item--fluid">
                        <div class="m-login__wrapper">
                            <div class="m-login__logo">
                                <a href="#">
                                    <img src="/media/img/logos/logo-2.png">
                                </a>
                            </div>
                            <div class="m-login__signin">
                                <!--                                <div class="m-login__head">-->
                                <!--                                    <h3 class="m-login__title">登陆面板</h3>-->
                                <!--                                </div>-->
                                <div class="m-login__form m-form">
                                    <div class="form-group m-form__group">
                                        <input class="form-control m-input" type="text" v-model="userForm.username"
                                               placeholder="请输入账号" name="username" autocomplete="off">
                                    </div>
                                    <div class="form-group m-form__group">
                                        <input class="form-control m-input m-login__form-input--last"
                                               v-model="userForm.password" type="password" placeholder="请输入密码"
                                               name="password">
                                    </div>
                                    <div class="form-group m-form__group">
                                        <input class="form-control m-input m-login__form-input--last"
                                               v-model="userForm.cipher"  type="text" placeholder="请输入口令"
                                               name="password">
                                    </div>
                                    <!--                                    <div class="row m-login__form-sub">-->
                                    <!--                                        <div class="col m&#45;&#45;align-left">-->
                                    <!--                                            <label class="m-checkbox m-checkbox&#45;&#45;focus">-->
                                    <!--                                                <input type="checkbox" name="remember"> 记住我-->
                                    <!--                                                <span></span>-->
                                    <!--                                            </label>-->
                                    <!--                                        </div>-->
                                    <!--                                        <div class="col m&#45;&#45;align-right">-->
                                    <!--                                            <a href="javascript:;" id="m_login_forget_password" class="m-link">忘记密码 ?</a>-->
                                    <!--                                        </div>-->
                                    <!--                                    </div>-->
                                    <div class="m-login__form-action">
                                        <button class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air"
                                                @click="handleLogin" :loading="button_loading">登陆
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1	m-login__content m-grid-item--center"
                 style="background-image: url(/media/img/bg/bg-4.jpg)">
                <div class="m-grid__item">
                    <h3 class="m-login__welcome">学枝系统</h3>
                    <p class="m-login__msg">
                        <!--Lorem ipsum dolor sit amet, coectetuer adipiscing<br>elit sed diam nonummy et nibh euismod-->
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "login",
        data() {
            return {
                path: "/user/login",
                button_loading: false,
                userForm: {
                    username: '',
                    password: '',
                    cipher:''
                },
                version: '',
            }
        },
        created() {
            this.destroyVuex();
            this.handleCreate();
        },
        beforeDestroy(){
            this.$wApi.removeListen(this.path)
        },
        methods: {
            handleCreate() {
                //初始化用户名
                if (localStorage.username) {
                    this.userForm.username = localStorage.username;
                }
                //建立webSocket链接
                this.$wApi.addListen(this.path, this.handleData)
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':

                        break;
                    case 'login':
                        this.button_loading = false;
                        localStorage.token = data.access_token;
                        localStorage.username = this.userForm.username;
                        this.$store.commit('profile', data.user);
                        if(data.simple){
                            this.$message.error('请修改密码');
                            this.router.push({path: '/changePassword'});
                        }else{
                            this.$message.success('登陆成功');
                            this.catchLogin();
                        }
                        break;
                    case 'login_error':
                        break;
                    case 'login_easy':

                        break;
                }
            },
            handleLogin() {
                this.button_loading = true;
                this.$wApi.send(this.path, 'login', {
                    'username': this.userForm.username,
                    'password': this.userForm.password,
                    'cipher':this.userForm.cipher
                });
            },
            catchLogin() {
                this.router.push({path: '/'});
            },
            destroyVuex() {
                this.$store.commit('setPowers', {'powers': []});
                this.$store.commit('setSemester', {'semester': {}});
                this.$store.commit('setSection', {'section': {}});
                this.$store.commit('setConfig', {'config': ''});
            },
            handleChange(){
                this.$wApi.send(this.path, 'changePassword', {
                    'username': this.userForm.username,
                    'password': this.changePasswordForm.password,
                    'password2': this.changePasswordForm.password2,
                });
            },

        }
    }
</script>

<style scoped lang="scss">

    .top-right {
        float: right;
        color: #fff;

    }

    .login {
        background-color: #161931;
        height: 100%;

        header {
            height: 40px;
            background-color: #fff;

            .right-menu {
                margin: 0;
                position: fixed;
                top: 0;
                right: 5px;
                display: flex;
                flex-direction: row;
                height: 40px;
                justify-content: center;
                align-items: center;
                z-index: 2000;

                li {
                    margin-left: 10px;
                    color: #788db4;
                    font-size: 15px;
                    flex: 1;
                    list-style-type: none;
                    padding: 8px 10px;
                }

                li:hover {
                    color: #6f42c1;
                    font-size: 15px;
                    flex: 1;
                    list-style-type: none;
                    background: rgba(0, 123, 255, 0.05);
                    border-radius: 5px;
                    cursor: pointer;
                }
            }

        }

        .login-button {
            width: 100%;
        }

        .logo {
            width: 200px;
        }


    }
</style>
